import React from "react";
import "../style/Filters.css";

const Filters = ({
  toggleFilters,
  filters,
  allFilters,
  toggleAll,
  actualFilters,
}) => {
  return (
    <div className="Filters">
      <div className="category">
        <p>Browse by Category</p>
        <div className="categoryButtons">
          <button
            className={filters.category.Energii ? "active" : null}
            data-filter="category"
            data-filter-name="Energii"
            data-actual-filter-name="Енергии"
            onClick={toggleFilters}
          >
            ENERGIZERS
          </button>
          <button
            className={filters.category.Inovacii ? "active" : null}
            data-filter="category"
            data-filter-name="Inovacii"
            data-actual-filter-name="Иновации"
            onClick={toggleFilters}
          >
            INNOVATION
          </button>
          <button
            className={filters.category.Liderstvo ? "active" : null}
            data-filter="category"
            data-filter-name="Liderstvo"
            data-actual-filter-name="Лидерство"
            onClick={toggleFilters}
          >
            SELF-LEADERSHIP
          </button>
          <button
            className={filters.category.Akcija ? "active" : null}
            data-filter="category"
            data-filter-name="Akcija"
            data-actual-filter-name="Акција"
            onClick={toggleFilters}
          >
            ACTION
          </button>
          <button
            className={filters.category.Tim ? "active" : null}
            data-filter="category"
            data-filter-name="Tim"
            data-actual-filter-name="тим"
            onClick={toggleFilters}
          >
            TEAM
          </button>
          <button className={allFilters ? "active" : null} onClick={toggleAll}>
            ALL
          </button>
        </div>
      </div>
      <div className="time">
        <p>Time frame (minutes)</p>
        <div className="timeButtons">
          <button
            className={filters.timeFrame.five_thirty_minutes ? "active" : null}
            data-filter="timeFrame"
            data-filter-name="five_thirty_minutes"
            data-actual-filter-name="5-30 минути"
            onClick={toggleFilters}
          >
            5-30
          </button>
          <button
            className={filters.timeFrame.thirty_sixty_minutes ? "active" : null}
            data-filter="timeFrame"
            data-filter-name="thirty_sixty_minutes"
            data-actual-filter-name="30-60 минути"
            onClick={toggleFilters}
          >
            30-60
          </button>
          <button
            className={
              filters.timeFrame.sixty_hundredandtwenty_minutes ? "active" : null
            }
            data-filter="timeFrame"
            data-filter-name="sixty_hundredandtwenty_minutes"
            data-actual-filter-name="60-120 минути"
            onClick={toggleFilters}
          >
            60-120
          </button>
          <button
            className={
              filters.timeFrame.hundredandtwenty_twohundredandfourty_minutes
                ? "active"
                : null
            }
            data-filter="timeFrame"
            data-filter-name="hundredandtwenty_twohundredandfourty_minutes"
            data-actual-filter-name="120-240 минути"
            onClick={toggleFilters}
          >
            120-240
          </button>
        </div>
      </div>
      <div className="size">
        <p>Group size</p>
        <div className="sizeButtons">
          <button
            className={filters.groupSize.two_ten ? "active" : null}
            data-filter="groupSize"
            data-filter-name="two_ten"
            data-actual-filter-name="2-10"
            onClick={toggleFilters}
          >
            2-10
          </button>
          <button
            className={filters.groupSize.ten_fourty ? "active" : null}
            data-filter="groupSize"
            data-filter-name="ten_fourty"
            data-actual-filter-name="2-40"
            onClick={toggleFilters}
          >
            10-40
          </button>
          <button
            className={filters.groupSize.fourty_plus ? "active" : null}
            data-filter="groupSize"
            data-filter-name="fourty_plus"
            data-actual-filter-name="2-40+"
            onClick={toggleFilters}
          >
            40+
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filters;
